import { render, staticRenderFns } from "./XDiyForm.vue?vue&type=template&id=e20c0f50&scoped=true"
import script from "./XDiyForm.vue?vue&type=script&lang=js"
export * from "./XDiyForm.vue?vue&type=script&lang=js"
import style0 from "./XDiyForm.vue?vue&type=style&index=0&id=e20c0f50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e20c0f50",
  null
  
)

export default component.exports